/** 请求成功 */
const SUCCESS = 100;

const SUBJECT_ID = 1;

const MENU_TYPE_ONE = 1; // 一级栏目类型1

const MENU_TYPE_TWO = 2; // 一级栏目类型2

const MENU_TYPE_THREE = 3; // 一级栏目类型3

const MENU_TYPE_FOUR = 4; // 一级栏目类型4

const MENU_TYPE_FIVE = 5; // 一级栏目类型5

const MENU_TYPE_SIX = 6; // 一级栏目类型6

const BIG_CAROUSEL_LOCATION = 1; // 大轮播图位置

const SMALL_CAROUSEL_LOCATION = 2; // 小轮播图位置

const INFO_DISCLOSURE = 26; // 信息公开

const TOPIC_COLUMN = 37; // 主题专栏

const STATE_GRID_INFO = 34; // 国网资讯

const GRASSROOTS_DYNAMICS = 33; // 基层动态

const INDUSTRY_NEWS = 9; // 行业动态

const MEDIA_FOCUS = 10; // 媒体聚焦

const FIRST_LINE_STYLE = 96; // 一线风采  党徽闪光

const COMPANY_NEWSPAPER = 35; // 公司报刊

const VIDEO_MATERIAL = 36; // 视频资料

const COMPANY_NEWS = 8; // 公司要闻

const INDUTRY_NEWS = 9; // 行业动态

const BUSINESS_AREA = 15; // 业务领域

const ONLINE_SERVICE = 22; // 在线服务

const ARTICLE = 1; // 点击的文章

const MENU = 2; // 点击的菜单

export default {
  SUCCESS,
  SUBJECT_ID,
  MENU_TYPE_ONE,
  MENU_TYPE_TWO,
  MENU_TYPE_THREE,
  MENU_TYPE_FOUR,
  MENU_TYPE_FIVE,
  MENU_TYPE_SIX,
  BIG_CAROUSEL_LOCATION,
  SMALL_CAROUSEL_LOCATION,
  INFO_DISCLOSURE,
  TOPIC_COLUMN,
  STATE_GRID_INFO,
  INDUSTRY_NEWS,
  MEDIA_FOCUS,
  FIRST_LINE_STYLE,
  COMPANY_NEWSPAPER,
  VIDEO_MATERIAL,
  COMPANY_NEWS,
  INDUTRY_NEWS,
  BUSINESS_AREA,
  GRASSROOTS_DYNAMICS,
  ONLINE_SERVICE,
  ARTICLE,
  MENU,
};



// WEBPACK FOOTER //
// ./src/api/codes.js